<template>
    <div class="wrapper">
        <div class="bigView">
            <!-- <div class="tv_section_heander"></div> -->
            <div class="div_cell" @click="goTobillList(4)">
                <span class="text_cell_tilte" @onclick="goTobillList(4)">月租车</span>
                <img class="image_cell_icon" @onclick="goTobillList(4)" :src="arrowIcon" />
            </div>
            <div class="div_lineBG">
                <div class="line"></div>
            </div>
            <div class="div_cell" @click="goTobillList(5)">
                <span class="text_cell_tilte" @onclick="goTobillList(5)">临停车</span>
                <img class="image_cell_icon" @onclick="goTobillList(5)" :src="arrowIcon" />
            </div>
            <div class="div_lineBG">
                <div class="line"></div>
            </div>
            <div class="div_cell" @click="goTobillList(1)">
                <span class="text_cell_tilte" @onclick="goTobillList(1)">会议室</span>
                <img class="image_cell_icon" @onclick="goTobillList(1)" :src="arrowIcon" />
            </div>
            <div class="div_lineBG">
                <div class="line"></div>
            </div>
            <!-- <div class="div_cell" @click="goTobillList(2)">
                <span class="text_cell_tilte" @onclick="goTobillList(2)">物业报修</span>
                <img class="image_cell_icon" @onclick="goTobillList(2)" :src="arrowIcon" />
            </div> -->
            <div class="tv_section_heander"></div>
            <div class="div_cell" @click="goToInvoiceHistory()">
                <span class="text_cell_tilte">开票历史</span>
                <img class="image_cell_icon"  :src="arrowIcon" />
            </div>
            <div class="div_lineBG">
                <div class="line"></div>
            </div>
            <div class="div_cell" @click="goToInvoiceHelp()">
                <span class="text_cell_tilte">开票帮助</span>
                <img class="image_cell_icon"  :src="arrowIcon" />
            </div>
        </div>
    </div>
</template>

<script>
    import {checkOpenReceipt} from '../../utils/api';
    import { mapState, mapActions } from "vuex";
    import util from '../../utils/util';
    export default {
        name: "index",
        components: {
        },
        data () {
            return {
                LmarketId:'',
                arrowIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAiVJREFUSA3dVTtIA0EQvcvl8kFTKFhESBHIB9JrwMagdSoFJdgIqZJGK1sbGwsbbaxMYSFRURTBQkhqCdgYyY+cECQQsVHM5R/fSA6uuNtcxCoLy+ztzry382Z3j+PGvhUKhZVyufxQLBZjf0nWxApKpVJmrO/ZbLZlk8l0lM/nt1n+WmtMglAo1OV5/rLdblMsD5J9ZLKhBaQ3x+stKPP9fl8E6LHVat3sdrscvr97vV7E6/XeKD4sy8yAApFB2263x1ut1oXZbOaQxQR6olQqLbGAlbWhBOTocrlkgEZBcg9LJFPop9lsNqgA6dmhEqkDq9XqTL1ev0UmQUjFQTIJcoUhV1btpx4bykAJcDqd79j5Oor+THOCILhhkrlcjqxmG4mAENxu9yt2vwYSibKwWCwBEJ2BZFaLYWQCAoEkLzCrnU7nDZ3DPZkHycG/ERAQpPqCaSmgyGZSGast3dSRG2mO4l6JovirvSzLeRBuaQGNdIoIgLTGKboG+BzVABK9Yjrs8Xh+C08+6iaoP4aNK5XKNECTAF9ABhx6FUd11efzPenFGi5yrVabbDQaCYAvDp6MDxBE/H7/ox44zRuSSJIkG47lCU7LOp0aZPHZbDYjgUDgjgVOa0OLnMlkRIAe4rGjC0YxMnYeNQJOzkyJsFPe4XDs4jJFBzvvQJ4Y7sE5BRtpTIJ0Oi3gNV2B7vSqgq+/g4ImjAAb9lH9MuOGg8bK8QfUePElzK6QFAAAAABJRU5ErkJggg==",

            }
        },
         computed: {
            ...mapState({
                    common: state => state.common
            })
        },
        created() {
            // let param = configObj.getParams(weex.config.bundleUrl);
            // this.LmarketId = param.marketId;
            // if(!this.LmarketId || this.LmarketId.length==0){
            //     let weexParams = weex.config.params
            //     this.LmarketId = weexParams.marketId;
            // }

        },

        methods: {
            goTobillList(type){
                // let params = {
                //     'marketId': this.LmarketId,
                //     'orderType':String(type), //"6608155D2DD44DBE8D139C3C9DFD7258",
                // }
                // console.log(JSON.stringify(params));

                // var url ='/InvoicingList?viewType=' + type;
                // this.$router.push({path:url});
                console.log("in push ")

                let params = {
                  marketId:this.common.marketInfo.id,
                   'orderType':String(type)
                };
                util.showLoading("加载中...");
                checkOpenReceipt(params).then(res => {
                    console.log(res);
                    util.hideLoading();
                    var isOpen  =false;
                    if(res.res.code ==10000 && res.body){
                        isOpen = res.body.isOpen;
                    }
                    if(isOpen){
                        var url ='/InvoicingList?viewType=' + type;
                        this.$router.push({path:url});
                    }else{
                        util.showToast(res.res.msg);
                    }

                });
            },

            goToInvoiceHistory(){
                var url = '/invoiceHistory'
                this.$router.push({path:url});
            },

            goToInvoiceHelp(){
                 var url = '/invoiceHelp'
                this.$router.push({path:url});
            }

        }
    }

</script>

<style scoped>
    .wrapper {
        background-color: #f3f4f6;
        height: 100vh;
    }
    .shop_list {
        flex: 1;
        height: 100vh;
    }
    .noMess{
        margin-top:300px;
    }

    .bigView{
        flex-direction: column;
        background-color:#fff;
    }

    .div_top{
        height: 14px;
        width: 750px;
        flex-direction:row;
    }


    .tv_section_heander{
        height: 14px;
        width: 750px;
        background-color:#f3f4f6 ;
    }

    .text_top{
        margin-left: 40px;
        margin-top: 20px;
        font-size: 48px;
        text-align: left;
        line-height: 60px;
        color: #333333;
        height: 60px;
        font-weight:bold;

    }

    .div_cell{
        height: 100px;
        width: 750px;
        flex-direction:row;
        display: flex;

    }

    .text_cell_tilte{

        margin-left: 40px;
        margin-top: 28px;
        font-size: 32px;
        text-align: left;
        line-height: 44px;
        color: #333333;
        height: 44px;
        width:646px ;
        display: flex;


    }

    .image_cell_icon{
        height: 24px;
        width: 24px;
        margin-top: 38px;
        margin-right: 40px;

    }


    .div_lineBG{
        width: 750px;
        flex-direction:row;

    }


    .line{
        background-color: #EAEAEA;
        height:2px;
        width: 710px;
        margin-left: 40px;
    }


</style>
